import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    keyword: "", //监听搜索关键字变化
    serviceId: "", //监听服务id变化
    
    navlist:[],
  },
  mutations: {
    changeData(state, params) {
      state.keyword = params
    },
    changeServiceId(state, params) {
      state.serviceId = params
    },
    changenavlist(state, params) {
      state.navlist = params
    }

  },
  actions: {},
  modules: {}
})